// extracted by mini-css-extract-plugin
export default {"title":"style_title__qp3Nc","tabHeader":"style_tabHeader__tbVMF","note":"style_note__TK2Y2","append":"style_append__76aWO"};